import { ALL_EXPORT_COLUMNS, getTableColumnId } from '../../export/utils/excel-columns.utils';
import { PersistOptions, persist } from 'zustand/middleware';
import create, { StateCreator } from 'zustand';

import fpGet from 'lodash/fp/get';
import fpSet from 'lodash/fp/set';

export const ACTION_SHEET_HIDDEN_COLUMNS: ReadonlyArray<string> = ['totalWeight', 'matSetName', 'dwpTotalWeight', 'totalEmission'];

const DEFAULT_HIDDEN_COLUMNS: Record<string, boolean> = {
   buCodePru: false,
   buCodePdu: false,
   familyName: false,
   recycledContent: false,
   renewableContent: false,
   updatedBy: false,
   comment: false,
   itemState: false,
   updatedAt: false,
   id: false,
   saleStartDateGlobal: false,
   saleEndDateGlobal: false,
   partsEmission: false,
   totalEmission: false,
};

export const HiddenCompositionSharePAs = ['1122-Pillows', '1213-Blinds', '1214-Curtain rods and systems'];

type HiddenColumnsMap = Record<string, boolean>;
type Updater<T> = T | ((prev: T) => T);

type HiddenColumnState = {
   hiddenColumns: HiddenColumnsMap;
   setHiddenColumns: (updater: Updater<HiddenColumnsMap>) => void;
   toggleColumn: (columnId: string) => void;
   getVisibleExportColumns: () => string[];
};

type HiddenColumnPersist = (
   config: StateCreator<HiddenColumnState>,
   options: PersistOptions<HiddenColumnState>
) => StateCreator<HiddenColumnState>;

export const useHiddenColumnState = create<HiddenColumnState>(
   (persist as unknown as HiddenColumnPersist)(
      (set, get) => ({
         hiddenColumns: DEFAULT_HIDDEN_COLUMNS,

         setHiddenColumns: (updater) => set((state) => ({
            hiddenColumns: typeof updater === 'function' ? updater(state.hiddenColumns) : updater
         })),
         toggleColumn: (columnId: string) => {
            const currentValue = fpGet(columnId)(get().hiddenColumns);
            const newValue = currentValue !== undefined ? !currentValue : false;
            set({ hiddenColumns: fpSet(columnId, newValue)(get().hiddenColumns) });
         },

         getVisibleExportColumns: () => {
            const hiddenColumns = get().hiddenColumns;

            const visibleColumns = ALL_EXPORT_COLUMNS.filter((exportColId) => {
               const tableColId = getTableColumnId(exportColId);
               return hiddenColumns[tableColId] !== false;
            });

            return visibleColumns;
         },
      }),
      { name: 'hidden-columns' }
   )
);
